import type { Abi } from 'viem';

import abiJson from 'shared/contract/contract.abi.json' with { type: 'json' };

// Use Vite env when present, otherwise fall back to Node env
const metaEnv = (typeof import.meta !== 'undefined' && (import.meta as any).env) || process.env;

export const RSP_CONTRACT_ADDRESS = (metaEnv?.VITE_RSP_CONTRACT_ADDRESS ||
  '0x0000000000000000000000000000000000000000') as `0x${string}`;

export const RSP_CONTRACT_ABI = abiJson as Abi;
